import { Dialog } from "primereact/dialog";
import React from "react";

interface CommenDialogProps {
    isOpen: boolean;
    title: string;
    description: React.ReactNode;
    buttonText: string;
    onClose: () => void;
}

export default function CommenDialog({
    isOpen,
    title,
    description,
    buttonText,
    onClose,
}: CommenDialogProps) {
    return (
        <Dialog
            visible={isOpen}
            onHide={onClose}
            closable={false}
            draggable={false}
            resizable={false}
            style={{ width: "400px" }}
        >
            <div className="d-flex flex-column align-items-center text-center gap-2 py-2">
                <img
                    src="/assets/images/success.svg"
                    alt="Success"
                    style={{ width: "70px" }}
                />

                <h4 className="fw-bold mb-1">
                    {title}
                </h4>

                <p
                    className="mb-2 text-muted"
                    style={{ fontSize: "14px", lineHeight: "20px" }}
                >
                    {description}
                </p>

                <button
                    className="btn btn-primary w-100"
                    style={{ height: "42px", fontSize: "15px" }}
                    onClick={onClose}
                >
                    {buttonText || "Close"}
                </button>
            </div>
        </Dialog>
    );
}